import gql from 'graphql-tag'

export const getUserStatistics = gql`
	query getUserStatistics($params: StatisticsUserParams) {
		cashAssist {
			getUserStatistics(params: $params)  {
				id
				time
				actionId
				userName
				name
				cashRegisterId
			}
		}
	}
`
